export const experimentalFeatureCheck = (
  user: any,
  experimentalFeatureName: string
) =>
  user.experimentalFeatures &&
  user.experimentalFeatures.find(
    (x: any) => x.toggleType === 1 && x.moduleName === experimentalFeatureName
  );